export var API_BASE_URL = process.env.REACT_APP_API_BASE || "https://shop-d81s.onrender.com";
// export var API_BASE_URL = process.env.REACT_APP_API_BASE || "http://localhost:8080";


const SHIPPING = {
    kurier:      { label: "Kuriér",       price: 6 },
    zasielkovna: { label: "Packeta",  price: 3 },
    osobny:      { label: "Osobný odber", price: 0 },
};
const PAYMENT = {
    kartou:   { label: "Prevodom", price: 0 },
    dobierka: { label: "Na dobierku", price: 1.5 },
};

export { SHIPPING, PAYMENT };